import * as Sentry from '@sentry/react'
import { isNonEmptyString } from 'src/shared/utils/is-nonempty-string'

export const initPublisherSentry = () => {
  const dsn = process.env.SENTRY_PUBLISHER_DSN
  if (!isNonEmptyString(dsn)) {
    return
  }
  Sentry.init({
    dsn,
    environment: process.env.APP_ENV,
    integrations: integrations =>
      integrations.filter(integration => integration.name !== 'GlobalHandlers'),
  })
}
